import {
  getInitFormData,
} from './utils.js';

export default {
  name: 'PartnershipHForm',
  model: {
    prop: 'formData',
    event: 'change'
  },  
  props: [
    'formData',
    'toggleContact', // 控制表单字段的显示隐藏 eg: moreContact
    'labelArray',    // BdoRadio component parameter (BdoRadio 组件按钮文案)
    'mode',          // BdoRadio component parameter (BdoRadio 组件是否必选)
    'toggleAcr',     // acrNumber show hidden ( acrNumber 显示隐藏)
    'selectOptions', // select option  (下拉框选项)
    'agencyBanking', // BusinessNature下来列表选择
    'disabled',
  ],
  data() {
    return {
      dFormData: {},
      options: {},
      bdoRadioLabelArray: [],
      bdoRadioMode: true,
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      // 将v-model传入的数据更新到组件data
      this.dFormData = Object.assign({}, this.dFormData, this.$props.formData);
      this.options = this.selectOptions ? this.selectOptions : {};
      
      // BdoRadio component parameter
      this.bdoRadioLabelArray = this.labelArray ? this.labelArray : [];
      this.bdoRadioMode = this.mode ? this.mode : true;
    })
  },
  methods: {
    // 更新 formData
    updateDataForm(val){
      this.dFormData = Object.assign({}, val);
    },
  },
  watch: {
    dFormData: function() {
      this.$emit('change', this.$data.dFormData)
    },
  },
   // 模板字符串同时存在 ''  和 ""  而做的处理
  template: `<div><el-form class="pc-wrap PartnershipH" label-position="top" ref="appForm" label-width="80px" :model="dFormData" :rules="formRules" :validateOnRuleChange="false" ><el-form-item label="Bank" prop="bank"><AccountType v-model="dFormData.bankType" /></el-form-item><el-form-item  v-show="toggleContact" label="Account Name" prop="accountName"><el-input v-model="dFormData.accountName"  placeholder="Account Name" maxlength="128" :clearable="!disabled" :disabled="disabled"></el-input></el-form-item><div class="el-form-item"></div><el-form-item  v-show="toggleContact" label="Account Number" prop="accountNumber"><el-input v-model="dFormData.accountNumber"  placeholder="Account Number" maxlength="12" :clearable="!disabled" :disabled="disabled"></el-input></el-form-item></el-form></div>`,
};